export default __webpack_public_path__ + "static/media/133.7586a914.png";